import { useParams } from "react-router-dom";
import SingleTeam from "../components/TeamsPage/SingleTeam";

type RouteParams = {
    slug?: string;
};

const Team = () => {
    const { slug } = useParams<RouteParams>();

    return (
        <main>
            {slug !== undefined && <SingleTeam slug={slug} />}
        </main>
    );
};

export default Team;
